import { Icon, SkeletonBar } from '@petsmart-ui/sparky';

import { AutoshipBadgeText, type AutoshipBadgeTextProps } from './AutoshipBadgeText';

import '@/components/AutoshipBadge/AutoshipBadge.scss';

export type AutoshipBadgeProps = Readonly<AutoshipBadgeTextProps & { isLoading?: boolean }>;

const AutoshipBadgeIcon = () => (
    <Icon name="autoship-fill" size="sm" className="autoship-badge__icon" data-testid="autoship-badge-icon" />
);

export const AutoshipBadge = ({ isLoading, ...props }: AutoshipBadgeProps) => {
    if (isLoading) {
        return (
            <div className="autoship-badge" data-testid="autoship-badge-skeleton">
                <SkeletonBar className="autoship-badge__text-skeleton" />
                <AutoshipBadgeIcon />
            </div>
        );
    }

    return (
        <div className="autoship-badge" data-testid="autoship-badge">
            <AutoshipBadgeText {...props} icon={<AutoshipBadgeIcon />} />
        </div>
    );
};
